/*
MFDApp.const.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

export const MFDApp = {
    storagePrefix: "xerox-autoredact-v2-",
    securedRoutes: [
    //   "/scan",
    //   "/browse",
    //   "/documenttype",
    //   "/destination",
    //   "/documentname",
    //   "/configuration"
    ],
    scanSettings: {
      items: [
        'TwoSided',
        'Resolution',
        'OutputColor',
        'OriginalType',
        'OriginalOrientation',
        'OriginalSize',
        'Quality'
      ],
      customDefaults: {
        Resolution: "300",
        Quality: "MediumCompression"
      }
    },
    maxRecipients: 20,
    maxRecentRecipients: 10,
    maxUploadSize_MB: 50,
  };